import React from 'react';
import Toast from './core/components/toast/toast.jsx';
import HeaderView from './features/header/view/header_view.jsx';
import HomeView from './features/home/view/home_view.jsx';
import InfosCardsView from './features/infos_cards/view/infos_cards_view.jsx';
import EnterpriseView from './features/enterprise/view/enterprise_view.jsx';
import SolutionsView from './features/solutions/view/solutions_view.jsx';
import TechnologyPartnersView from './features/technology_partners/view/technology_partners_view.jsx';
import GetInTouchView from './features/get_in_touch/view/get_in_touch_view.jsx';
import OtherSolutionsView from './features/other_solutions/view/other_solutions_view.jsx';
import FrequentlyAskedQuestionsView from './features/frequently_asked_questions/view/frequently_asked_questions_view.jsx';
import ContactView from './features/contact/view/contact_view.jsx';
import FooterView from './features/footer/view/footer_view.jsx';

const App: React.FC = () => {
  return (
    <div>
      <Toast />
      <HeaderView />
      <div className="app-main">
        <div id="home">
          <HomeView />
        </div>
        <InfosCardsView />
        <div id="empresa">
          <EnterpriseView />
        </div>
        <div id="solucoes">
          <SolutionsView />
        </div>
        <TechnologyPartnersView />
        <GetInTouchView />
        <OtherSolutionsView />
        <FrequentlyAskedQuestionsView />
        <div id="contato">
          <ContactView />
        </div>
        <FooterView />
      </div>
    </div>
  );
};

export default App;
